import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'decision-maker-self-service-responses',
		path: '/admin/decision-makers/self-service-responses',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin-decisionMakerSelfServiceResponses" */ './index'),
			{
				exportName: 'AdminDmSelfServiceResponses',
				fallback: Loading,
			},
		),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
